function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "logg_out");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ustawienia---wylogowano",
  transform: "translate(-720.000000, -333.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(544.000000, 301.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "wylogowanie",
  transform: "translate(138.604651, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "logg_out",
  transform: "translate(37.395349, 21.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M171.12037,90.3175684 C175.899981,90.3175684 180.483763,92.2126529 183.863024,95.5857957 C187.242285,98.9589385 189.140117,103.533734 189.138889,108.303465 L153.097222,108.303465 C153.097222,103.533309 154.996084,98.9585255 158.37608,95.5855156 C161.756076,92.2125056 166.340334,90.3175684 171.12037,90.3175684 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.810185,99.331307 C197.200817,99.331307 199.493535,100.279019 201.183967,101.965957 C202.874399,103.652895 203.824074,105.940875 203.824074,108.326565 L185.800926,108.326565 C185.800926,103.360425 189.83376,99.3338577 194.810185,99.331307 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.518519,10.8894833 L76.7361111,1.25203647 C75.5049176,0.929833997 74.1936019,1.1955819 73.1858772,1.97151783 C72.1781524,2.74745375 71.587963,3.94585487 71.587963,5.21604863 L71.587963,111.015441 L113.518519,111.015441 L113.518519,10.8894833 Z",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.7777778,91.9808127 C73.5041923,91.9808127 73.2824061,91.7594638 73.2824061,91.4864438 L73.2824061,5.0312462 C73.2813491,3.60651997 73.9429815,2.26199273 75.0733787,1.39174858 C76.2037758,0.521504435 77.6748979,0.224115703 79.0555556,0.58674772 L115.837963,10.2241945 C116.051296,10.2789507 116.203589,10.4665787 116.212963,10.6862006 L116.212963,59.5987842 C116.212963,59.8743558 115.989105,60.0977508 115.712963,60.0977508 C115.436821,60.0977508 115.212963,59.8743558 115.212963,59.5987842 L115.212963,11.0881459 L78.8009259,1.54772036 C77.7190175,1.26397923 76.5664174,1.49731044 75.6808312,2.17934922 C74.7952449,2.86138801 74.2769403,3.91491266 74.2777778,5.0312462 L74.2777778,91.4772036 C74.2802849,91.6107112 74.2285638,91.7395526 74.1343846,91.8344074 C74.0402054,91.9292622 73.9115793,91.9820617 73.7777778,91.9808127 L73.7777778,91.9808127 Z",
  id: "Path",
  stroke: "#5B5B5B",
  fill: "#5B5B5B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(107.414352, 20.963526) rotate(180.000000) translate(-107.414352, -20.963526) ",
  x: 102.884259,
  y: 16.4427964,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(94.743056, 20.963526) rotate(180.000000) translate(-94.743056, -20.963526) ",
  x: 90.212963,
  y: 16.4427964,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(82.076389, 20.963526) rotate(180.000000) translate(-82.076389, -20.963526) ",
  x: 77.5462963,
  y: 16.4427964,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(107.414352, 34.555745) rotate(180.000000) translate(-107.414352, -34.555745) ",
  x: 102.884259,
  y: 30.0350152,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(94.743056, 34.555745) rotate(180.000000) translate(-94.743056, -34.555745) ",
  x: 90.212963,
  y: 30.0350152,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(82.076389, 34.555745) rotate(180.000000) translate(-82.076389, -34.555745) ",
  x: 77.5462963,
  y: 30.0350152,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(107.414352, 48.157204) rotate(180.000000) translate(-107.414352, -48.157204) ",
  x: 102.884259,
  y: 43.6364742,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(94.743056, 48.157204) rotate(180.000000) translate(-94.743056, -48.157204) ",
  x: 90.212963,
  y: 43.6364742,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(82.076389, 48.157204) rotate(180.000000) translate(-82.076389, -48.157204) ",
  x: 77.5462963,
  y: 43.6364742,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(94.743056, 61.749422) rotate(180.000000) translate(-94.743056, -61.749422) ",
  x: 90.212963,
  y: 57.228693,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(82.076389, 61.749422) rotate(180.000000) translate(-82.076389, -61.749422) ",
  x: 77.5462963,
  y: 57.228693,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(94.743056, 75.346261) rotate(180.000000) translate(-94.743056, -75.346261) ",
  x: 90.212963,
  y: 70.8255319,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(82.076389, 75.346261) rotate(180.000000) translate(-82.076389, -75.346261) ",
  x: 77.5462963,
  y: 70.8255319,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.606481,58.9981763 L162.282407,58.9981763 L162.282407,110.534954 C162.282407,113.24219 160.083214,115.436839 157.37037,115.436839 L108.518519,115.436839 C105.805675,115.436839 103.606481,113.24219 103.606481,110.534954 L103.606481,58.9981763 L103.606481,58.9981763 Z",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  transform: "translate(132.944444, 87.217508) rotate(-180.000000) translate(-132.944444, -87.217508) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.300926,117.964012 L105.800926,117.964012 C105.524784,117.964012 105.300926,117.740617 105.300926,117.465046 L105.300926,63.2116717 C105.303477,60.9494677 107.140518,59.1162239 109.407407,59.1136778 L160.041667,59.1136778 C162.308556,59.1162239 164.145597,60.9494677 164.148148,63.2116717 L164.148148,116.379331 C164.166424,116.568207 164.075763,116.75108 163.914226,116.85118 C163.752689,116.95128 163.548237,116.95128 163.3867,116.85118 C163.225163,116.75108 163.134502,116.568207 163.152778,116.379331 L163.152778,63.2116717 C163.150224,61.4988084 161.75808,60.111609 160.041667,60.1116109 L109.407407,60.1116109 C107.692802,60.1141553 106.303476,61.5006104 106.300926,63.2116717 L106.300926,116.966079 L117.300926,116.966079 C117.577068,116.966079 117.800926,117.189474 117.800926,117.465046 C117.800926,117.740617 117.577068,117.964012 117.300926,117.964012 L117.300926,117.964012 Z",
  id: "Path",
  stroke: "#5B5B5B",
  fill: "#5B5B5B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(153.293981, 69.104559) rotate(180.000000) translate(-153.293981, -69.104559) ",
  x: 148.763889,
  y: 64.5838298,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(140.627315, 69.104559) rotate(180.000000) translate(-140.627315, -69.104559) ",
  x: 136.097222,
  y: 64.5838298,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(127.956019, 69.104559) rotate(180.000000) translate(-127.956019, -69.104559) ",
  x: 123.425926,
  y: 64.5838298,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(153.293981, 82.701398) rotate(180.000000) translate(-153.293981, -82.701398) ",
  x: 148.763889,
  y: 78.1806687,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(140.627315, 82.701398) rotate(180.000000) translate(-140.627315, -82.701398) ",
  x: 136.097222,
  y: 78.1806687,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(127.956019, 82.701398) rotate(180.000000) translate(-127.956019, -82.701398) ",
  x: 123.425926,
  y: 78.1806687,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  cx: 167.810185,
  cy: 135.594164,
  rx: 57.0462963,
  ry: 7.69702128
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.736111,127.097872 C149.006419,127.097872 143.550926,132.54209 143.550926,139.257872 L167.921296,139.257872 C167.921296,132.54209 162.465803,127.097872 155.736111,127.097872 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.148148,118.832584 C169.844209,118.832584 160.680556,127.977297 160.680556,139.257872 L201.615741,139.257872 C201.615741,127.977297 192.452087,118.832584 181.148148,118.832584 L181.148148,118.832584 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.884259,129.435623 C188.425737,128.534007 188.438011,127.411089 187.916369,126.497901 C187.394727,125.584713 186.420222,125.023147 185.366918,125.028717 C184.313614,125.034371 183.345174,125.60629 182.833333,126.524985 C181.441619,125.752808 179.68652,126.237252 178.890237,127.613362 C178.093954,128.989473 178.550824,130.748583 179.916667,131.565471 C179.142891,132.954309 179.628338,134.70578 181.007298,135.500418 C182.386259,136.295055 184.149012,135.839129 184.967593,134.476109 C186.359307,135.248286 188.114406,134.763842 188.910689,133.387732 C189.706972,132.011621 189.250102,130.252511 187.884259,129.435623 L187.884259,129.435623 Z",
  id: "Path",
  stroke: "#5B5B5B",
  strokeWidth: 3,
  fill: "#FFFFFF",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.365741,131.343708 C184.897823,132.152426 183.861564,132.429509 183.051145,131.962602 C182.240727,131.495696 181.963014,130.461593 182.430843,129.652825 C182.898672,128.844056 183.934901,128.56686 184.74537,129.033678 C185.135572,129.257006 185.420444,129.626372 185.536887,130.059963 C185.65333,130.493554 185.591733,130.955581 185.365741,131.343708 L185.365741,131.343708 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.037037,126.206201 C170.402879,125.389312 170.85975,123.630202 170.063467,122.254092 C169.267184,120.877982 167.512085,120.393537 166.12037,121.165714 C165.30179,119.802695 163.539037,119.346768 162.160076,120.141406 C160.781116,120.936043 160.295668,122.687514 161.069444,124.076353 C159.703602,124.893241 159.246731,126.652351 160.043015,128.028461 C160.839298,129.404572 162.594397,129.889016 163.986111,129.116839 C164.497952,130.035534 165.466392,130.607453 166.519696,130.613107 C167.573,130.618677 168.547505,130.057111 169.069147,129.143923 C169.590789,128.230735 169.578515,127.107817 169.037037,126.206201 L169.037037,126.206201 Z",
  id: "Path",
  stroke: "#5B5B5B",
  strokeWidth: 3,
  fill: "#FFFFFF",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.898148,126.589666 C165.087679,127.056484 164.05145,126.779288 163.583621,125.970519 C163.115792,125.16175 163.393505,124.127648 164.203923,123.660741 C165.014341,123.193835 166.050601,123.470918 166.518519,124.279635 C166.744511,124.667762 166.806107,125.12979 166.689664,125.563381 C166.573221,125.996972 166.28835,126.366338 165.898148,126.589666 L165.898148,126.589666 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(153.293981, 95.351125) rotate(180.000000) translate(-153.293981, -95.351125) ",
  x: 148.763889,
  y: 90.8303951,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(140.627315, 95.351125) rotate(180.000000) translate(-140.627315, -95.351125) ",
  x: 136.097222,
  y: 90.8303951,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  transform: "translate(127.956019, 95.351125) rotate(180.000000) translate(-127.956019, -95.351125) ",
  x: 123.425926,
  y: 90.8303951,
  width: 9.06018519,
  height: 9.04145897
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#009693",
  fillRule: "nonzero",
  x: 24.6759259,
  y: 104.163891,
  width: 16.1111111,
  height: 6.74528875
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5925926,95.5613374 C7.10121456,95.5613374 0.217592593,102.430732 0.217592593,110.904559 L30.9629637,110.904559 C30.9641911,106.835709 29.3453596,102.933088 26.4627229,100.055543 C23.5800861,97.177998 19.6698705,95.5613374 15.5925926,95.5613374 Z",
  id: "Path",
  fill: "#009693",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.6018519,85.1338602 C46.3396096,85.1338602 34.7777778,96.6717952 34.7777778,110.904559 L86.4259259,110.904559 C86.4259259,104.069745 83.7051831,97.5148668 78.8622297,92.6819232 C74.0192764,87.8489796 67.4508221,85.1338602 60.6018519,85.1338602 Z",
  id: "Path",
  fill: "#009693",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.9490741,91.7913678 C55.1818439,90.9487537 57.3379239,89.9162216 59.3935185,88.7051672 C54.9830432,84.7237583 51.1040011,80.1928117 47.8518519,75.2238298 C49.7902123,74.6031258 51.6534881,73.7694837 53.4074074,72.7382371 C48.4027778,68.3122188 44.1481481,62.1860182 40.8055556,55.103465 C37.4537037,62.1860182 33.2083333,68.3122188 28.2037037,72.7382371 C29.957623,73.7694837 31.8208988,74.6031258 33.7592593,75.2238298 C30.4940534,80.1951756 26.6009265,84.7262165 22.1759259,88.7051672 C24.2329532,89.9096664 26.3888633,90.9374803 28.6203704,91.7775076 C25.4271078,96.0421739 21.8184459,99.9807482 17.8472222,103.535562 C32.8657407,112.290578 48.7083333,112.290578 63.7268519,103.535562 C59.7560325,99.984011 56.1459606,96.0502329 52.9490741,91.7913678 L52.9490741,91.7913678 Z",
  id: "Path",
  fill: "#009693",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.5462963,103.549422 C62.5723447,99.995959 58.9620191,96.0572614 55.7685185,91.7913678 C58.0008766,90.9477941 60.1568759,89.9153007 62.212963,88.7051672 C57.8010048,84.7239041 53.920413,80.1929648 50.6666667,75.2238298 C52.6053707,74.6040209 54.468744,73.7703352 56.2222222,72.7382371 C51.2222222,68.3122188 46.962963,62.1860182 43.6203704,55.103465 C40.2685185,62.1860182 36.0231481,68.3122188 31.0185185,72.7382371 C32.7724378,73.7694837 34.6357136,74.6031258 36.5740741,75.2238298 C33.3133423,80.1958283 29.4231809,84.7270399 25,88.7051672 C27.0565634,89.9105379 29.2125495,90.938388 31.4444444,91.7775076 C28.2509439,96.0434013 24.6406182,99.9820988 20.6666667,103.535562",
  id: "Path",
  stroke: "#5B5B5B",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#33B3A5",
  fillRule: "nonzero",
  x: 77.4861111,
  y: 116.27769,
  width: 13.5787037,
  height: 5.68267477
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.8287037,109.033435 C62.6694569,109.033435 56.8657407,114.825155 56.8657407,121.969605 L82.7916667,121.969605 C82.7916667,114.825155 76.9879505,109.033435 69.8287037,109.033435 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.259259,95.7553799 C105.293266,95.7553799 98.6127172,98.5175223 93.6878846,103.433909 C88.7630519,108.350295 85.9975437,115.01801 85.9999984,121.969605 L138.513891,121.969605 C138.516345,115.01881 135.751472,108.351796 130.827641,103.435542 C125.90381,98.5192887 119.22445,95.756605 112.259259,95.7553799 L112.259259,95.7553799 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.314815,105.854833 C103.195497,105.146408 105.012257,104.279319 106.74537,103.262979 C103.029817,99.9078241 99.7622542,96.0895723 97.0231481,91.9022492 C98.649321,91.3772233 100.212725,90.675378 101.685185,89.8093617 C97.4722222,86.0809726 93.8935185,80.9111246 91.0694444,74.9466261 C88.2453704,80.9111246 84.6666667,86.0809726 80.4490741,89.8093617 C81.922707,90.6762532 83.4877433,91.3781343 85.1157407,91.9022492 C82.3764701,96.0894494 79.1089249,99.9076811 75.3935185,103.262979 C77.126632,104.279319 78.9433915,105.146408 80.8240741,105.854833 C78.1322609,109.44707 75.0912438,112.765002 71.7453704,115.760243 C84.3981481,123.15234 97.7546296,123.15234 110.412037,115.760243 C107.058623,112.767007 104.011272,109.448932 101.314815,105.854833 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.768519,115.760243 C109.427482,112.764326 106.391138,109.446416 103.703704,105.854833 C105.584386,105.146408 107.401146,104.279319 109.134259,103.262979 C105.418853,99.9076811 102.151308,96.0894494 99.412037,91.9022492 C101.040034,91.3781343 102.605071,90.6762532 104.078704,89.8093617 C99.8611111,86.0809726 96.287037,80.9111246 93.4583333,74.9466261 C90.6342593,80.9111246 87.0555556,86.0809726 82.8425926,89.8093617 C84.313586,90.6750707 85.8754218,91.3769089 87.5,91.9022492 C84.7608939,96.0895723 81.4933316,99.9078241 77.7777778,103.262979 C79.5108912,104.279319 81.3276507,105.146408 83.2083333,105.854833 C80.5162541,109.448275 77.4735758,112.766327 74.125,115.760243",
  id: "Path",
  stroke: "#5B5B5B",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 40.6435185,
  y: 91.3432219,
  width: 23.0231481,
  height: 53.578845
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.6666667,150.854225 L37.6851852,150.854225 L37.6851852,145.772158 C37.6851852,144.769384 38.4997782,143.956474 39.5046296,143.956474 L64.8148148,143.956474 C65.8196662,143.956474 66.6342593,144.769384 66.6342593,145.772158 L66.6666667,150.854225 Z",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.1157407,88.1322766 L44.1944444,88.1322766 C43.2523036,88.1310514 42.3483964,88.5039981 41.6822016,89.1688159 C41.0160069,89.8336338 40.6422878,90.7356727 40.6435155,91.6758663 L40.6435155,94.8868085 L63.6666667,94.8868085 L63.6666667,91.6758663 C63.6666667,89.7187974 62.076863,88.1322766 60.1157407,88.1322766 Z",
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  x: 40.6435185,
  y: 94.8868085,
  width: 23.0231481,
  height: 1.95890578
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C1E0DB",
  fillRule: "nonzero",
  x: 40.6435185,
  y: 137.183465,
  width: 23.0231481,
  height: 6.74990881
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9814815,151.630395 L40,151.630395 L40,146.525228 C40,146.043679 40.1916909,145.581852 40.5329029,145.241346 C40.874115,144.900839 41.3368978,144.709544 41.8194444,144.709544 L67.1759259,144.709544 C67.6584726,144.709544 68.1212554,144.900839 68.4624674,145.241346 C68.8036795,145.581852 68.9953704,146.043679 68.9953704,146.525228 L68.9814815,151.630395 Z",
  id: "Path",
  stroke: "#5B5B5B",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66,91.1353191 C65.8414741,89.3060888 64.3074537,87.9012766 62.4675926,87.9012766 L46.5462963,87.9012766 C44.7055147,87.9012766 43.1700576,89.3053642 43.0092593,91.1353191 L43.0092593,91.1353191 L43.0092593,144.728024 L66.0185185,144.728024 L66.0185185,91.1353191 L66,91.1353191 Z",
  id: "Path",
  stroke: "#5B5B5B",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#5B5B5B",
  fillRule: "nonzero",
  points: "165.592593 111.066261 55.25 111.066261 55.25 102.657751 166.666667 102.657751"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#5B5B5B",
  fillRule: "nonzero",
  cx: 55.25,
  cy: 106.862006,
  rx: 6.19444444,
  ry: 6.18164134
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "71.6296296 102.657751 66.0833333 102.657751 60.0416667 111.066261 65.5925926 111.066261"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "82.7777778 102.657751 77.2314815 102.657751 71.1898148 111.066261 76.7361111 111.066261"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "93.9259259 102.657751 88.375 102.657751 82.337963 111.066261 87.8842593 111.066261"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "105.074074 102.657751 99.5231481 102.657751 93.4814815 111.066261 99.0324074 111.066261"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "116.222222 102.657751 110.671296 102.657751 104.62963 111.066261 110.180556 111.066261"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "127.37037 102.657751 121.819444 102.657751 115.777778 111.066261 121.328704 111.066261"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "138.513889 102.657751 132.967593 102.657751 126.925926 111.066261 132.476852 111.066261"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "149.662037 102.657751 144.115741 102.657751 138.074074 111.066261 143.62037 111.066261"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero",
  points: "160.810185 102.657751 155.259259 102.657751 149.217593 111.066261 154.768519 111.066261"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.666667,102.657751 L166.388889,102.657751 L160.37037,111.066261 L166.666667,111.066261 C168.967853,111.066261 170.833344,109.204637 170.833344,106.908207 L170.833344,106.825046 C170.835793,105.720661 170.397892,104.660668 169.616223,103.878882 C168.834555,103.097096 167.773342,102.657751 166.666667,102.657751 L166.666667,102.657751 Z",
  id: "Path",
  fill: "#EDA242",
  fillRule: "nonzero"
}))))));

var Svg502V2 = function Svg502V2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "225px",
    height: "155px",
    viewBox: "0 0 225 155",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg502V2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/502v2.5c2cc9f4.svg";
export { ForwardRef as ReactComponent };